import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { generatePDFReport, getResults, PDFReportRequestBody } from '../../api/resultsAPI';
import { SmartVacuumDTO } from '../../dto/product/SmartVacuumDTO';
import { ResultsRequestBody } from '../filter/filterSlice';

interface ResultState {
  value: SmartVacuumDTO | null;
  isLoading: LoadingType;
  error: string | null;
  pdf: Blob | null;
  isLoadingPDF: LoadingType;
}

export type LoadingType = 'idle' | 'pending' | 'success' | 'error';

const initialState: ResultState = {
  value: null,
  isLoading: 'idle',
  error: null,
  pdf: null,
  isLoadingPDF: 'idle',
};

function startLoading(state: ResultState) {
  state.isLoading = 'pending';
  state.value = null;
}

function startLoadingPDF(state: ResultState) {
  state.isLoadingPDF = 'pending';
}

export const fetchResults = createAsyncThunk('fetchResults', async (body: ResultsRequestBody) => {
  const response = await getResults(body);
  return response;
});

export const fetchPDFReport = createAsyncThunk('fetchPDFReport', async (body: PDFReportRequestBody) => {
  const response = await generatePDFReport(body);
  return response;
});

export const resultsSlice = createSlice({
  name: 'results',
  initialState,
  reducers: {
    clearPDF: (state) => {
      state.pdf = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchResults.pending, startLoading);
    builder.addCase(fetchResults.fulfilled, (state, { payload }) => {
      state.value = payload;
      state.isLoading = 'success';
      state.error = null;
    });
    builder.addCase(fetchResults.rejected, (state, action) => {
      state.isLoading = 'error';
      state.error = action.error.message || 'Fetching results failed';
    });
    builder.addCase(fetchPDFReport.pending, startLoadingPDF);
    builder.addCase(fetchPDFReport.fulfilled, (state, { payload }) => {
      state.pdf = payload;
      state.isLoadingPDF = 'success';
    });
    builder.addCase(fetchPDFReport.rejected, (state, action) => {
      state.isLoadingPDF = 'error';
      state.error = action.error.message || 'Fetching pdf failed';
    });
  },
});

export const { clearPDF } = resultsSlice.actions;
export default resultsSlice.reducer;
